// Generated by ReScript, PLEASE EDIT WITH CARE


var title = {
  id: "3cb1c957-d005-4aa3-a7c9-4a49d1386955",
  defaultMessage: "Search for actions"
};

var flashMarketingActionID = {
  id: "5f1565d3-4329-4158-b2d7-b01ad0621472",
  defaultMessage: "Action ID"
};

var bonusLabel = {
  id: "4c5f2a12-eb60-4bfe-843e-c22490fe9157",
  defaultMessage: "Action label"
};

var bonusType = {
  id: "3782d5a5-c7ba-4f4d-b5b4-9b56e1d66b0f",
  defaultMessage: "Action type"
};

var resultInfo = {
  id: "3559167f-fd42-46a1-adcc-dae51d68b639",
  defaultMessage: "actions"
};

var fleetTable = {
  id: "c5c9041f-2052-4655-bbfa-95e42029b97b",
  defaultMessage: "Fleet"
};

var nonFleetTable = {
  id: "bccc9898-d0dd-4e9c-9cd5-45f9ca1bbac6",
  defaultMessage: "DMF/ PARC"
};

var searchForAction = {
  id: "c1925e87-e3e3-4827-bcc6-9ef2877777bf",
  defaultMessage: "You need to select an order type before searching for action"
};

var numberValFrom = {
  id: "b3f10ed6-6316-4409-abf0-4d3eb644a96e",
  defaultMessage: "From"
};

var numberValTo = {
  id: "691ff28c-80d6-4552-927f-8f4ae00d544e",
  defaultMessage: "To"
};

var detentionDurationMin = {
  id: "45607855-12b6-4508-a21e-221883fc5173",
  defaultMessage: "Min duration of detention (in days)"
};

var detentionDurationMax = {
  id: "47ab1b17-4b4c-4501-920b-2e010ccd6af0",
  defaultMessage: "Max duration of detention (in days)"
};

var ordetTypeOnlyFleetOrNonfleet = {
  id: "5424873d-6c44-4d33-a881-9b38ba4836a9",
  defaultMessage: "The SO command type cannot be selected with any other command type."
};

var startDateFrom = {
  id: "991bc082-da0f-4f84-94d6-7aae1929d06b",
  defaultMessage: "Start date from"
};

var startDateTo = {
  id: "0f798a2f-4828-40d0-9dae-43c18be250ac",
  defaultMessage: "Start date to"
};

var endDateFrom = {
  id: "ede97e54-1dac-4593-b944-4a9672adcdf9",
  defaultMessage: "End date from"
};

var endDateTo = {
  id: "4b91d043-db2e-4d0a-a18e-5e853342e698",
  defaultMessage: "End date to"
};

export {
  title ,
  flashMarketingActionID ,
  bonusLabel ,
  bonusType ,
  resultInfo ,
  fleetTable ,
  nonFleetTable ,
  searchForAction ,
  numberValFrom ,
  numberValTo ,
  detentionDurationMin ,
  detentionDurationMax ,
  ordetTypeOnlyFleetOrNonfleet ,
  startDateFrom ,
  startDateTo ,
  endDateFrom ,
  endDateTo ,
}
/* No side effect */
